export const calculateAndFormatDifference = (scenarioOnePayment, scenarioTwoPayment) => {
    if (scenarioTwoPayment === scenarioOnePayment){
        return '£0 per month';
    }

    const symbol = scenarioTwoPayment > scenarioOnePayment ? '+' : '-'
    return `${symbol} £${(Math.abs((scenarioTwoPayment) - (scenarioOnePayment))).toLocaleString()} per month`;
}